module.exports = __webpack_public_path__ + "img/FILE1.6b5b8b83.png";